'use client';

import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { MdOutlinePhoneInTalk } from 'react-icons/md';
import { AiOutlineMail } from 'react-icons/ai';
import { LanguageSelect } from '@eliadmin/core/src/components/header/language-select';
import { FaRegClock } from 'react-icons/fa6';

export function Topbar({
  generalLayout,
}: {
  locale?: string;
  generalLayout: GeneralLayout['data'];
}) {
  const { t } = useTranslations();

  return (
    <div className={cn('custom-section', 'hidden bg-foreground py-2 md:flex')}>
      <div className={cn('custom-container', 'flex min-w-0 items-center justify-between gap-4')}>
        <div className="flex min-w-0 max-w-full flex-wrap items-center justify-start gap-x-4 gap-y-2 xl:gap-x-6">
          <Paragraph size="sm" color="white">
            {t('text611')}
          </Paragraph>
          <Link
            prefetch={false}
            href={`tel:${generalLayout?.contact?.phone}`}
            target="_blank"
            className="flex min-w-0 max-w-full items-center justify-start gap-2 break-all text-xs font-semibold text-white transition-all hover:opacity-90 lg:text-sm"
          >
            <MdOutlinePhoneInTalk size={20} className="shrink-0" />
            {generalLayout?.contact?.phone}
          </Link>
          <Link
            prefetch={false}
            href={`mailto:${generalLayout?.contact?.email}`}
            target="_blank"
            className="flex min-w-0 max-w-full items-center justify-start gap-2 break-all text-xs font-semibold text-white transition-all hover:opacity-90 lg:text-sm"
          >
            <AiOutlineMail size={20} className="shrink-0" />
            {generalLayout?.contact?.email}
          </Link>
          <div className="flex items-center justify-start gap-2 text-xs font-light text-white lg:text-sm">
            <FaRegClock size={20} />
            Po-Pia 8:00-17:00
          </div>
        </div>
        <div className="hidden">
          <LanguageSelect />
        </div>
      </div>
    </div>
  );
}
